import React, { Component } from 'react';
import baseUrl from '../../utils/baseUrl';

import PublicVoting from './publicvoting';
import sponsor from './tceay-sponsor.png';

export default class TCEAY extends Component {
	static propTypes = {};

	constructor(props) {
		super(props);

		this.state = {
			blurb: 'tceay/blurb',
			head: 'tceay/head',
			subhead: 'tceay/subhead',
			confirm: 'tceay/confirm',
			about: 'tceay/about',
			ribbonStyle: 'tcea',
			voteUrl: `${baseUrl}/api/account/jury/tceay`,
			sponsor,
		};
	}

	render() {
		return <PublicVoting {...this.state} />;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/containers/publicvoting/tceay.js
 **/